import {
  ArcheType, PersonCard, SocialLink, SocialLinks,
} from 'Types/PersonTypes';
import {
  discPlaceholder,
  maxTablet,
  maxWidth,
  minWidthApp,
  noPersonImage,
  primaryColor,
  primaryFont,
  retina, secondaryFont,
  wMBold,
  wMLight,
  wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import React from 'react';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { actions as helperActions } from 'Slice/HelperSlice';
import styled from 'styled-components';
import { Divider } from 'antd';
import SmallButton from 'Components/common/components/SmallButton';
import DrawerPeopleMoveReason from 'Components/people/components/DrawerPeopleMoveReason';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsRecommended } from 'Selector/PersonProfileSelector';
import { selectData } from 'Selector/CertificationSelector';
import { valueToObject } from 'Utils/UtilityFunctions';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import TwitterIcon from '../../common/assets/svgIcons/TwitterIcon';
import LinkedInIcon from '../../common/assets/svgIcons/LinkedInIcon';

const StyledWrapper = styled.div<{ color: string }>`
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
  min-height: 87px;
  height: 87px;
  width: 100%;
  z-index: 0;
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 14px 8px 19px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    height: 85px;
    min-height: 85px;
  }
  @media all and (min-height: ${maxTablet}) {
    min-height: 87px;
    height: 87px;
  }
  @media all and (max-width: ${maxTablet}) {
    height: 68px;
    min-height: 68px;
    margin-bottom: 8px !important;
  }
 .person-card {
  margin-right: 16px;
  .image-persona {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 70px;
    border: 2px solid #A5A5A5;
    border-radius: 50%;
    @media all and (max-width: ${maxTablet}) {
      width: 55px;
      height: 55px;
    }
    .person-img {
      width: inherit;
      height: inherit;
      border-radius: 50%;
      padding: 2px;
    }
  }
 }
 .person-info-dv {
  display: flex;
  flex-direction: column;
  width: calc(100% - 86px);
  @media all and (max-width: ${maxTablet}) {
    width: calc(100% - 71px);
  }
  .name-social-icons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2px;
    .person-name {
      color: #0D0D0D;
      font-family: ${secondaryFont};
      font-size: 22px;
      font-weight: ${wMBold};
      line-height: 26px;
      letter-spacing: -0.553px;
      margin-bottom: 0px;
      width: calc(100% - 42px);
      @media all and (max-width: ${maxTablet}) {
        font-size: 20px;
        line-height: 24px;
      }
    }
    .social-icons-wrap {
      height: 16px;
      display: flex;
      flex-direction: row-reverse;
      .scc-place {
        &.twit-icon {
          margin-right: 10px;
        }
        svg {
          height: 16px;
          width: 16px;
        }
      }
    }
  }
  .company-designation-div {
    display: flex;
    align-items: center;
    margin-bottom: 3px;
    .company-name {
      &.designation-person {
        color: #67696A;
        font-weight: ${wMedium};
        max-width: 70%;
      }
      color: ${primaryColor};
      font-family: ${primaryFont};
      font-size: 12px;
      font-weight: ${wMLight};
      line-height: normal;
      letter-spacing: -0.244px;
      max-width: 30%;
    }
    .ant-divider {
      border-left: 1px solid #D8D8D8;
      margin: 0px 4px 0px 6px;
    } 
  }
  .buttons-div {
    display: flex;
    align-items: center;
    height: 18px;
    @media all and (max-width: ${maxTablet}) {
      height: 16px;
    }
    .small-button-chinese {
      height: 18px;
      font-size: 12px;
      font-weight: ${wMBold};
      line-height: normal;
      padding: 0px 10.5px;
      @media all and (max-width: ${maxTablet}) {
        font-size: 10px;
        height: 16px;
      }
    }
    .drawer-btn-action {
      .ant-badge {
        .btn-notes-drawer {
          margin-left: 6px;
          max-height: 18px;
          height: 18px;
          font-size: 12px;
          font-weight: ${wMBold};
          line-height: normal;
          padding: 0px 9px;
          @media all and (max-width: ${maxTablet}) {
            font-size: 10px;
            max-height: 16px;
            height: 16px;
            margin-bottom: 7px;
          }
          svg {
            height: 10px;
            width: 10px;
            margin-bottom: 1px;
            margin-right: 5px;
            @media all and (max-width: ${minWidthApp}) {
              display: none;
            }
            @media all and (max-width: ${maxTablet}) {
              display: block;
            }
          }
        }
        .ant-badge-dot {
          width: 8px;
          height: 8px;
          border: 1px solid rgb(255, 255, 255);
          top: 0px;
        }
      }
    }
  }
 }
`;
type Props = {
  personInfo?: PersonCard;
  socialLinks?: SocialLinks;
  personFollowLoading?: boolean,
  onClickHandler?: () => void,
  personAdded?: boolean,
  hideFollow?: boolean,
  archeType?: ArcheType;
  personImage?: string,
  personName?: string,
  companyName?: string,
  personDesignation?: string,

} & typeof defaultProps;

const defaultProps = {
  personInfo: {},
  socialLinks: { data: [] } as SocialLinks,
  personFollowLoading: false,
  onClickHandler: () => { },
  personAdded: true,
  hideFollow: false,
  archeType: {
    color: '#ff0000',
    image: `${discPlaceholder}`,
    name: '',
    personality: '',
  },
  personImage: '',
  personDesignation: '',
  personName: '',
  companyName: '',
};
const GilroyPersonHeader = function GilroyPersonHeader(props: Props) {
  const {
    socialLinks, personFollowLoading, onClickHandler, personAdded,
    personInfo, hideFollow, archeType, personImage,
    personName, personDesignation, companyName,

  } = props;
  const { color } = archeType;
  const dispatch = useDispatch();
  const isRecommended = useSelector(selectIsRecommended);
  const host = window.location.href;
  const data = useSelector(selectData);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const handleClick = () => {
    onClickHandler();
    if (!personAdded) {
      dispatch(certificationActions.certificationAction({
        type: 'person_follow',
        source: 'search',
        data,
      }));
    }
    if (isRecommended) {
      dispatch(helperActions.callFlurryEvent(
        valueToObject('peopleDashboard_recommended_follow_person', 0, {
          person_id: personInfo.personId,
          host,
        }),
      ));
    }
  };
  return (
    <StyledWrapper
      className={classNames('gilroy-header person-gilroy-header')}
      color={color}
    >
      <div className="person-card">
        <div className="image-persona">
          <img src={disclessPersonality ? noPersonImage : personImage} alt="person-img" className="person-img" />
        </div>
      </div>
      <div className="person-info-dv">
        <div className="name-social-icons">
          <h2 className="person-name text-truncate">{personName}</h2>
          {!disclessPersonality && (
            <div className={classNames('social-icons-wrap')}>
              {socialLinks?.data?.map((item: SocialLink) => {
                if (item.link && item.type === 'twitter') {
                  return (
                    <a key={item.link} href={item.link} target="_blank" className="social-icon scc-place twit-icon" rel="noreferrer">
                      <TwitterIcon />
                    </a>
                  );
                }
                if (item.link && item.type === 'linkedin') {
                  return (
                    <a key={item.link} href={item.link} target="_blank" className="social-icon scc-place" rel="noreferrer">
                      <LinkedInIcon />
                    </a>
                  );
                }
                return null;
              })}
            </div>
          )}
        </div>
        <div className="company-designation-div">
          <span className="company-name text-truncate">{companyName}</span>
          {!companyName && !personDesignation ? null : <Divider type="vertical" />}
          <span className="company-name designation-person text-truncate">{personDesignation}</span>
        </div>
        <div className="buttons-div">
          {!hideFollow
            && (
              <SmallButton
                title={personAdded ? 'Unfollow' : 'Follow'}
                variant={personAdded ? 'outlined' : 'filled'}
                color="#001760"
                loading={personFollowLoading}
                onButtonClick={handleClick}
              />
            )}
          {hideFollow ? null : (
            <div>
              <DrawerPeopleMoveReason
                isPeopleNotes
                personId={personInfo.personId}
              />
            </div>
          )}
        </div>
      </div>
    </StyledWrapper>
  );
};
GilroyPersonHeader.defaultProps = defaultProps;
export default GilroyPersonHeader;
